import { BlockerFunction, useBlocker } from "react-router";

import { useEventListener } from "@nens/react/hooks";

// In our useRouteBlocker hook we want to support both the react-router blocking and the beforeunload event.
// The react-router blocking is already supported by the useBlocker hook, but we need to add support for the beforeunload event ourselves.
// To do this we define a new type RouteBlockerFunction that can be used in both cases.
// The function will receive an object with either the currentLocation and nextLocation properties (for react-router) or an eventType property (for beforeunload).
// The function should return true if the route change should be blocked, or false if it should be allowed.

type ReactRouterBlockerArgs = Parameters<BlockerFunction>[0];
type BeforeUnloadBlockerArgs = { eventType: "beforeunload" };

export type RouteBlockerFunction = (
  args: ReactRouterBlockerArgs | BeforeUnloadBlockerArgs
) => boolean;

export function useRouteBlocker(when: boolean | RouteBlockerFunction) {
  const blocker = useBlocker(when);

  useEventListener("beforeunload", (e) => {
    const shouldBlock = typeof when === "function" ? when({ eventType: "beforeunload" }) : when;

    if (shouldBlock) {
      e.preventDefault();
    }
  });

  return blocker;
}
